// it's a js file because it needs to be imported in next.config.js file as well
const imageDomains = [
  // 'cdn.indiawealth.in', not being used any more
  // 'cdn.indmoney.com',
  'localhost',
  'indcdn.indmoney.com',
]

module.exports = imageDomains
